/**
 * Created by TANKSKE on 9/3/2017.
 */
(function() {
    'use strict';

    var deps = [
        'doclr.components.validations',
        'doclr.components.copyright',
        'doclr.components.notification',
        'doclr.components.loading',
        'doclr.components.vertalingen',
        'doclr.resources.common',
        'doclr.components.util',
        'doclr.components.loading',
        'doclr.cities.api',
        'ui.bootstrap',
        'ngMaterial',
        'ngAnimate',
        'ui.router',
        'ngMessages',
        'doclr.monkeypoxsubscription',
        // 'rcForm'
    ];

    angular.module('doclr.monkeypoxsubscription.app',deps)
        .config(function($mdThemingProvider,$uiViewScrollProvider) {
            moment.locale('nl');
            $mdThemingProvider.theme('default')
           .accentPalette('blue');

            $uiViewScrollProvider.useAnchorScroll();
    })
        .run(function($injector,$animate, $rootScope, $log) {
            $animate.enabled(true);
            $rootScope.$on('$stateChangeError', $log.error.bind($log.error));
        })

    .controller('MonkeypoxSubscriptionController', function () {


    });
})();
